import { render } from "./callHistoryModel.vue?vue&type=template&id=0d71109d"
import script from "./callHistoryModel.vue?vue&type=script&lang=js"
export * from "./callHistoryModel.vue?vue&type=script&lang=js"

import "./callHistoryModel.vue?vue&type=style&index=0&id=0d71109d&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__